// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__3z-YP {\n  margin-bottom: 16px; }\n\n.Section_cardSection__2ut-0 {\n  margin-top: 36px;\n  margin-bottom: 18px; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__3z-YP",
	"cardSection": "Section_cardSection__2ut-0"
};
module.exports = exports;
